import { makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import { GetApplicationCollaboration } from '@/application/collaborations/get-application.collaboration';
import type { ApplicationDto } from '@/application/interfaces/pegasus.gateway';

@singleton()
export class ApplicationModel {
  @observable application: ApplicationDto;

  constructor(private getApplicationCollaboration: GetApplicationCollaboration) {
    makeObservable(this);
  }

  async getApplication() {
    try {
      const { data } = await this.getApplicationCollaboration.run();

      this.application = data;
    } catch (error) {
      console.error(error);
    }
  }
}
